
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "m58 36.6c0 8.5-11.7 15.4-26 15.4-14.4 0-26-6.9-26-15.4 0-8.5 11.6-15.4 26-15.4 14.3 0 26 6.9 26 15.4", fill: "#94989b" }),
	React.createElement("path", { d: "m62 30.9c0 10.4-13.4 18.9-30 18.9-16.6 0-30-8.4-30-18.9 0-10.5 13.4-18.9 30-18.9 16.6 0 30 8.4 30 18.9", fill: "#c7d7d7" }),
	React.createElement("path", { d: "m56.7 29.2c0-6.9-11.1-12.6-24.7-12.6-13.6 0-24.7 5.6-24.7 12.6 0 3.9 3.5 7.4 9.1 9.7.3.3.6 1 .1 2.2-.8 2 2.1 4.6 4.7 3.1s6.4-1 7.8 0 5.4 1.4 7.5 0 3.7-2.4 7.2-2.4 6.2-3.6 8-5c0 0 0 0 0 0 3.2-2.1 5-4.7 5-7.6", fill: "#ba5327" }),
	React.createElement(
		"g",
		{ fill: "#fbbf67" },
		React.createElement("path", { d: "m52.4 28c-1.5-2.5-4.8 1-6.7.5-4.2-1.1-1.1 5 .6 5.3 2 .4 7.6-3.3 6.1-5.8" }),
		React.createElement("path", { d: "m37.5 33.8c-3-.1-3.4-1-4.9.4-3.2 3 6.7 6.4 7.9 5.2 1.4-1.5 0-5.5-3-5.6" }),
		React.createElement("path", { d: "m43 20.5c-3.5-.1-3.7-.7-5.4 1-3.8 3.6 1.2 7.5 2.6 6 1.6-1.8 6.2-6.9 2.8-7" }),
		React.createElement("path", { d: "m26.3 32.1c-2.8-.3-6.5 1.5-6.8 4-.3 2.4 1.4 4.2 3.4 3.6 2-.6 3.1-3.6 4.1-4.6 1-1 .9-2.8-.7-3" })
	),
	React.createElement("path", { d: "m31 13.8c-1.3-.2-2.2 2.3-3.5 2.1-.9-.1-2.9-2-3.7-1.8-1 .2-2.3 3.1-3.3 3.4-1.4.3-2-2.5-3.4-2.1-3.3.9-5.1 6.4-8.8 6.4-2.8.1-5.7 10-2.7 10 5.4 0 4.9 3.3 5.6 3.3.8.1.8-2.6 1.4-3 .8-.6 3.1.5 3.8-.2.6-.5 0-2.7.6-3.2.7-.6 2.9.7 3.8.3.5-.2.7-2.5 1.1-2.1 3 3.2 5 1.9 5.6.5.4-1-1.4-3.5-.6-4.3.8-.8 2.7 2.7 3.7 2.2.4-.2.1-1.5.4-1.7.6-.5 2.5 1 3 .3.3-.5-1.2-1.9-.9-2.4.4-.6 2.2.6 2.8.2 1-.5 2-3.7 1.8-4.8-.5-1.7-5.3-2.9-6.7-3.1", fill: "#fffbe9" }),
	React.createElement(
		"g",
		{ fill: "#e8e1d6" },
		React.createElement("path", { d: "m14.7 18.3c-1.2 1.7-1.6 3.5-1 4 .6.5 2-.4 3.2-2.1 1.2-1.7 1.6-3.5 1-4-.6-.5-2 .4-3.2 2.1" }),
		React.createElement("path", { d: "m18.6 27.3c-1.7-.9-3.4-1.1-3.7-.3-.3.7.8 2.1 2.5 3 1.7.9 3.4 1.1 3.7.3.3-.8-.8-2.1-2.5-3" }),
		React.createElement("path", { d: "m9.3 25c-1.5 1.2-2.3 2.8-1.8 3.4.2.3 1.4-.8 1.1 2-.2 1.8 2.1 0 3.5-1.3 3.2-3.2.7-6.9-2.8-4.1" }),
		React.createElement("path", { d: "m25.4 23.9c.8-.1-.4-2.3-1.8-3.6-1.5-1.3-3.4-1.9-3.5-1.1-.2 1.9-1.2 1.3-1.4 1.7-.4.7.5 2.3 2.1 3.4 1.5 1.1 3.1 1.5 3.5.8.1-.3-.7-1.1 1.1-1.2" }),
		React.createElement("path", { d: "m33.5 18.7c1.5-1.2 2.3-2.8 1.8-3.4-.5-.7-3.9 1.8-7.1.9-1.8-.5-3.5.6-3.5 1.4 0 .6.7 1.1 1.8 1.4-.5.9-.7 1.7-.3 2.1.5.6 2.1 0 3.5-1.3 0-.3 2.3.1 3.8-1.1" })
	),
	React.createElement(
		"g",
		{ fill: "#699635" },
		React.createElement("path", { d: "m16.8 24.4c-.6-1.9-2.4-3.2-2.4-3.2s.2 2 .4 2.9c-2-.8-2-4.7-2-4.7s-1.3.9-1.2 2.4c-2.2-1.9-4-1-4-1s2.7 1.7 3.1 2.9c-1.5.1-2.4.7-3 2.1 0 0 3-1.6 5.3-.4-.9.8-.4 2.8-.4 2.8 3.6-4.2 5.9-.4 7.5-1.5-1.2-2-3.3-2.3-3.3-2.3" }),
		React.createElement("path", { d: "m37.6 14.3c0 0-2.1 1.5-3 1.3.5-1.3.5-2.2-.2-3.1 0 0-.2 3-1.8 4.3-.2-1-1.6-1.4-1.6-1.4 1.3 4.5-2 4.8-2 6.4 1.8-.2 2.7-1.7 2.7-1.7 1.4.3 2.9-.6 2.9-.6s-1.3-.6-2-.8c1.2-1.2 3.7.2 3.7.2s0-1.4-1-1.9c2.2-1 2.3-2.7 2.3-2.7" })
	)
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/curry.js
// module id = 691
// module chunks = 0